class AdminHeader {
  constructor() {
    this.breadcrumbsContainer = jQuery(".page-header-breadcrumbs");
    this.originalBreadcrumbs = this.breadcrumbsContainer.find(".page-header-breadcrumb");
    this.ellipses = jQuery('<li class="page-header-breadcrumb">...</li>');
    this.popover = jQuery('<div class="breadcrumbs-popover"></div>')
      .appendTo(this.ellipses)
      .append(this.originalBreadcrumbs.clone());

    this.render();

    // BEHAVIOUR

    jQuery(window).on("resize", this.render.bind(this));
  }

  render() {
    let breadcrumbsToRemove = jQuery();
    let breadcrumbs = this.originalBreadcrumbs;

    while (breadcrumbs.length > 2 && this._getWidth(breadcrumbs) > this.breadcrumbsContainer.width()) {
      let breadcrumbToRemove = this._getMiddleBreadcrumb(breadcrumbs);
      breadcrumbsToRemove = breadcrumbsToRemove.add(breadcrumbToRemove);
      this._hideBreadcrumbs(breadcrumbToRemove);
      breadcrumbs = breadcrumbs.not(breadcrumbToRemove);
    }

    this._showBreadcrumbs(breadcrumbs.not(breadcrumbsToRemove));

    if (breadcrumbsToRemove.length && !this.ellipses.parent().length) {
      this.ellipses.insertBefore(breadcrumbsToRemove.first());
    } else if (!breadcrumbsToRemove.length) {
      this.ellipses.remove();
    }
  }

  _getWidth(breadcrumbs) {
    let width = 0;

    breadcrumbs.each(function () {
      width += jQuery(this).outerWidth(true);
    });

    return width;
  }

  _getMiddleBreadcrumb(breadcrumbs) {
    return breadcrumbs.eq(Math.floor(breadcrumbs.length / 2));
  }

  _hideBreadcrumbs(breadcrumb) {
    return breadcrumb.filter(":not(.hidden)").hide().addClass("hidden");
  }

  _showBreadcrumbs(breadcrumbs) {
    return breadcrumbs.filter(".hidden").show().removeClass("hidden");
  }
}

window.AdminHeader = AdminHeader;
